import { Action } from "redux";
import { put, select, takeLatest } from "redux-saga/effects";
import { isActionOf } from "typesafe-actions";

import { updateMetadata } from "@app/store/iam/actions";
import BaseLayerData from "@app/store/mapLayers/BaseLayerData";
import { getTrafficLayerData } from "@app/store/mapLayers/selectors";

import { toggleLayerLegendExpandedState, toggleLayerVisibility } from "../actions";

export function* onPersistTrafficSettings() {
  const layerData: BaseLayerData = yield select(getTrafficLayerData);
  yield put(updateMetadata.request({ trafficSettings: layerData }));
}

const isToggleVisibilityOrLegendAction = isActionOf([
  toggleLayerVisibility,
  toggleLayerLegendExpandedState,
]);

export function* trafficLayerSagas() {
  yield takeLatest(
    (action: Action) =>
      isToggleVisibilityOrLegendAction(action) && action.payload.name === "traffic",
    onPersistTrafficSettings
  );
}
